import IPlugin from "./plugin";
import PluginError from "../errors/plugin.error";
import $services from "../services";

const ERROR_NO_REPOSITORIES = 'Please add repositories manager to the Vue config before using Services plugin.';

export default class ServicesPlugin extends IPlugin {
    setup(Vue, config) {
        if (!config.repositories) {
            throw new PluginError(this, ERROR_NO_REPOSITORIES);
        }
        $services.config.modals.repositories = config.repositories;
        config.services = $services;
        Vue.mixin({
            beforeCreate() {
                this.$services = $services;
            }
        });

        return super.setup(Vue, config);
    }
}